module.exports = __webpack_public_path__ + "static/media/FederalDistricts.cba241fd.svg";